exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InputField-module__form___22H2j{border-radius:4px;display:grid;grid-template-columns:1fr auto;transition:.2s}.InputField-module__form___22H2j input{background:none;border:none;text-align:center;grid-column:1/3;grid-row:1;padding:0;margin:0}", ""]);

// exports
exports.locals = {
	"form": "InputField-module__form___22H2j"
};